import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { ConstantValues } from "common/constants";
import { setCurrentConversation } from "../redux/conversations";
import { setCurrentMessages } from "../redux/messages";
import { setCurrentPrompt } from "../redux/selectedPrompt";
import { setTagsForKey } from "../redux/tags";
import { clearLibraryDocumentsForKey } from "../redux/workspaceLibraryDocuments";
import { clearReferencedConversations } from "../redux/referencedConversationsSlice";
import { setNewConfigForKey } from "../redux/llmConfig";

/**
 * Returns a function that resets all chat-related state to defaults.
 * Use when switching workspaces or navigating away from a conversation
 * to prevent stale chat context from leaking across workspaces.
 */
export const useChatStateReset = () => {
  const dispatch = useDispatch();

  const resetChatState = useCallback((): void => {
    dispatch(
      setCurrentPrompt({
        key: ConstantValues.CHAT,
        prompt: { description: ConstantValues.EMPTY_STRING },
      }),
    );
    dispatch(setCurrentMessages([]));
    dispatch(setCurrentConversation(null));
    dispatch(setTagsForKey({ key: ConstantValues.CHAT, tags: [] }));
    dispatch(clearLibraryDocumentsForKey(ConstantValues.CHAT));
    dispatch(clearReferencedConversations());
    dispatch(
      setNewConfigForKey({
        key: ConstantValues.CHAT,
        config: {
          rag: false,
          citate: false,
          sourceRagCategories: [],
        },
      }),
    );

    localStorage.removeItem(ConstantValues.DRAFT_MESSAGE_CONVERSATION_ID);
  }, [dispatch]);

  return resetChatState;
};
